// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_paymentInput__QNno0 {
  background-color: #F3F5F7;
  padding: 18px 16px;
  border-radius: 12px;
  vertical-align: middle;
  outline: none;
}

.styles_cancel__lHoDu {
  border: 2px solid #343839;
  color: #313333;
}

.styles_create__BRMEd {
  background-color: #29B473;
  color: #FEFEFE;
}
.styles_createDisabled__2es2D {
  opacity: 0.58;
}

.styles_button__MUejb {
  max-width: 348px;
  width: 100%;
  padding: 12px 24px;
  border-radius: 12px;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/NewPaymentMethod/styles.module.scss","webpack://./src/constants/colors.scss","webpack://./src/constants/fonts.scss"],"names":[],"mappings":"AAGA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;AADF;;AAIA;EACE,yBAAA;EACA,cCZM;ADWR;;AAIA;EACE,yBCdM;EDeN,cCdM;ADaR;AAGE;EACE,aAAA;AADJ;;AAKA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EAEA,kCE7BQ;EF8BR,gBAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJF","sourcesContent":["@import 'constants/fonts.scss';\n@import 'constants/colors.scss';\n\n.paymentInput {\n  background-color: #F3F5F7;\n  padding: 18px 16px;\n  border-radius: 12px;\n  vertical-align: middle;\n  outline: none;\n}\n\n.cancel {\n  border: 2px solid #343839;\n  color: $black;\n}\n\n.create {\n  background-color: $green;\n  color: $white;\n\n  &Disabled {\n    opacity: 0.58;\n  }\n}\n\n.button {\n  max-width: 348px;\n  width: 100%;\n  padding: 12px 24px;\n  border-radius: 12px;\n\n  font-family: $poppins;\n  font-weight: 600;\n  font-size: 16px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n","$gray: #6C7275;\n$black: #313333;\n$blue: #0084FF;\n$green: #29B473;\n$white: #FEFEFE;\n","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap');\n\n$poppins: 'Poppins', sans-serif;\n$roboto: 'Roboto', sans-serif;\n$inter: 'Inter', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentInput": `styles_paymentInput__QNno0`,
	"cancel": `styles_cancel__lHoDu`,
	"create": `styles_create__BRMEd`,
	"createDisabled": `styles_createDisabled__2es2D`,
	"button": `styles_button__MUejb`
};
export default ___CSS_LOADER_EXPORT___;
